(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-details.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/result-details.js');

'use strict';

const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.react.components,
  MapSingle = _svs$lyckoplatsen$com.MapSingle,
  PeppText = _svs$lyckoplatsen$com.PeppText,
  Distribution = _svs$lyckoplatsen$com.Distribution;
const ResultDetails = _ref => {
  let _ref$wagers = _ref.wagers,
    wagers = _ref$wagers === void 0 ? null : _ref$wagers,
    result = _ref.result,
    _ref$results = _ref.results,
    results = _ref$results === void 0 ? null : _ref$results,
    _ref$showBtnCenterSwe = _ref.showBtnCenterSweden,
    showBtnCenterSweden = _ref$showBtnCenterSwe === void 0 ? false : _ref$showBtnCenterSwe,
    _ref$showHomeLocation = _ref.showHomeLocationButton,
    showHomeLocationButton = _ref$showHomeLocation === void 0 ? false : _ref$showHomeLocation;
  return React.createElement("div", {
    className: "lp-result-details"
  }, React.createElement(MapSingle, {
    wagers: wagers,
    result: result,
    results: results,
    showBtnCenterSweden: showBtnCenterSweden,
    showHomeLocationButton: showHomeLocationButton
  }), React.createElement("div", {
    className: "details-wrapper"
  }, React.createElement(PeppText, {
    result: result
  }), React.createElement(Distribution, {
    result: result
  })));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ResultDetails
});

 })(window);